import { call,put, takeLatest } from "redux-saga/effects";
import { fetchNotificationFailure, fetchNotificationSuccess, fetchSetNotificationFailure, fetchSetNotificationSuccess, fetchToggleNotificationFailure, fetchToggleNotificationSuccess, SetNotificationRequest } from "./actions";
import api from "../../../api-new/http";
import { appUrls } from "../../../api-new/urls";
import { sendError } from "../../public/errorHandler";
import { getErrorSetup } from "../../../helpers/getErrorSetup";
import { FETCH_NOTIFICATION_REQUEST, SET_NOTIFICATION_REQUEST, TOGGLE_NOTIFICATION_REQUEST } from "./constants";
import { notification } from "antd";


export function* notificationSaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/notifications`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchNotificationSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchNotificationFailure(error as any));
        // yield put(
        //     sendError({
        //         error: getErrorSetup(error),
        //         processingType: 'alert',
        //     }),
        // );
    }
}



export function* toggleNotificationSaga() {
    try {
        // Make API request to toggle the notification settings
        const data = yield call(() =>
            api.get(`${appUrls.authenURL}/toggle-notification`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        
        if (data) {
            // Dispatch success action if data is returned
            yield put(fetchToggleNotificationSuccess());
            
            // Show success notification
            notification.success({
                message: 'Settings Updated Successfully',
                description: 'Your preferences have been updated. Please log in again to apply the changes.',
            });
        }
    } catch (error) {
        console.log(error)
        // Handle failure if there's an error
        yield put(fetchToggleNotificationFailure());
        
        // Send error details
        yield put(
            sendError({
                error: getErrorSetup(error), // Ensure getErrorSetup function is defined properly
                processingType: 'alert',
            }),
        );
    }
}


export function* setPriceNotificationSaga(action: SetNotificationRequest) {
    try {
        const { payload } = action;
        const data = yield call(() =>
            api.post(`${appUrls.authenURL}/set-notification`, payload, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if(data){
            notification.success({
                message: "Price Notification Set Successfully",
                description: "Your price notification settings have been updated successfully. You will be alerted when the specified price thresholds are reached.",
            });
            
            yield put(fetchSetNotificationSuccess());
        }
    } catch (error) {
        console.log(error)
        yield put(fetchSetNotificationFailure());  
        yield put(
            sendError({
                error: getErrorSetup(error), 
                processingType: 'alert',
            }),
        );
    }
}





export function* rootNotificationSaga(): Generator {
    yield takeLatest(FETCH_NOTIFICATION_REQUEST, notificationSaga);
    yield takeLatest(TOGGLE_NOTIFICATION_REQUEST, toggleNotificationSaga);
    yield takeLatest(SET_NOTIFICATION_REQUEST, setPriceNotificationSaga);
    
}
